module.exports = __webpack_public_path__ + "img/lens-160-minus-07.90fb11bf.png";